<template>

    <div class="container">

        <div class="container loginFormWrapper">
            <div class="loginForm">
                <h3>Login?</h3>
                <LoginForm :nonce="loginNonce" :siteKey="siteKey" />
            </div>
            <div class="alignCenter registrationCTA">
                <h3>Not Registered?</h3>
                <p>Registration provides useful benefits.<br /> You can save listings for later!</p>
                <hr class="small" />
                <a href="/register" class="btn btn-primary btn-large">Register</a>
            </div>
        </div>
    </div>

</template>

<script>
import { mapState }    from 'pinia';
import { globalStore } from "../stores/global.js";
import { loginStore }  from "../stores/login.js";

import LoginForm from "../forms/LoginForm.vue";

export default {
    name: "LoginApp",
    components: {
        LoginForm
    },
    computed: {
        ...mapState(loginStore, {
            loginNonce: store => store.nonces.login,
        }),
        ...mapState(globalStore, {
            isUserAuthenticated: store => store.isUserAuthenticated,
            siteKey: store => store.siteKey
        })
    },
};
</script>

<style>
</style>
